export const WarrantyWorkOrderCenterRouting = [
  {
    path: "/maintenance/warrantyWorkOrderCenter",
    name: "maintenance-warrantyWorkOrderCenter-list",
    meta: { title: "保修工单中心" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-warrantyWorkOrderCenter" */ "@/views/maintenance/warrantyWorkOrderCenter/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/warrantyWorkOrderCenter/create",
    name: "maintenance-warrantyWorkOrderCenter-create",
    meta: { title: "新建保修工单", comName: "WarrantyWorkOrderCenterFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-warrantyWorkOrderCenter" */ "@/views/maintenance/warrantyWorkOrderCenter/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/warrantyWorkOrderCenter/edit/:id",
    name: "maintenance-warrantyWorkOrderCenter-edit",
    meta: { title: "编辑保修工单", comName: "WarrantyWorkOrderCenterFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-warrantyWorkOrderCenter" */ "@/views/maintenance/warrantyWorkOrderCenter/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/warrantyWorkOrderCenter/detail/:id",
    name: "maintenance-warrantyWorkOrderCenter-detail",
    meta: { title: "保修工单详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-warrantyWorkOrderCenter" */ "@/views/maintenance/warrantyWorkOrderCenter/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/warrantyWorkOrderCenter/flowPrint/:id",
    name: "maintenance-warrantyWorkOrderCenter-flow-print",
    meta: { title: "保修工单打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-warrantyWorkOrderCenter" */ "@/views/maintenance/warrantyWorkOrderCenter/flow-print/index.vue"
      ),
  },
];
